// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ad-2";
export var aiChatCartContainerExit = "_ad-4";
export var aiChatContainerLarge = "_ad-0";
export var aiChatContainerSmall = "_ad-1";
export var aiChatIcon = "_ad-6";
export var slideInFromRight = "_ad-3";
export var slideOutToRight = "_ad-5";